import React from "react";
import Dealership from "../components/Contact/dealership-enquiry"; 
import Banner from '../comman/Banner/Banner';


const Dealershipenquire = () => {
  return (
    <>
    <Banner 
     index={'react-delership'}
    />
    <Dealership/>    
    </>

  )
};

export default Dealershipenquire;